import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import chapsSubmittedContent, { contentPropTypes } from './chapsSubmitted.content';
import ChapsSubmittedPayments from './ChapsSubmittedPayments';

class ChapsSubmittedPage extends Component {
	componentDidMount() {
		this.props.handleComplete();
	}

	render() {
		const { content, handleReset, handleRoute } = this.props;

		return (
			<div>
				<PageHeading isFlush data-test-id="chaps-submitted-page">
					{content.PageHeader}
				</PageHeading>
				<p className="u-margin-top-1">{content.PageSubHeader}</p>
				<ChapsSubmittedPayments handleRoute={handleRoute} />
				<div className="u-margin-top-2" data-cy="servicing-section">
					<ButtonGroup>
						<Button
							data-cy="button-web-homepage"
							display="secondary"
							className="u-margin-right-1"
							onClick={() => handleRoute('WEB-HOMEPAGE')}
						>
							{content.accountsButtonLabel}
						</Button>
						<Button
							id="makeAnotherPaymentButton"
							display="secondary"
							className="u-margin-right-1"
							onClick={handleReset}
							data-cy="button-make-another-payment"
						>
							{content.anotherPaymentButtonLabel}
						</Button>
						<Button
							display="secondary"
							data-cy="button-payment-status"
							onClick={() => handleRoute('WEB-MANAGE-PAYMENT-STATUS')}
						>
							{content.paymentStatusButtonLabel}
						</Button>
					</ButtonGroup>
				</div>
			</div>
		);
	}
}

ChapsSubmittedPage.defaultProps = {
	handleComplete: () => {},
};

ChapsSubmittedPage.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payments: PropTypes.shape({}),
	handleReset: PropTypes.func.isRequired,
	handleRoute: PropTypes.func,
	handleComplete: PropTypes.func,
};

export default compose(withContent({ content: chapsSubmittedContent }), withScrollTop)(ChapsSubmittedPage);
